module.exports = __webpack_public_path__ + "img/selected4-min.91198b9b.png";